import {NgModule} from '@angular/core';
import {CommonModule} from "@angular/common";
import {FormsModule} from "@angular/forms";
import {IonicModule} from "@ionic/angular";
import {TopToolbarComponent} from "./top-toolbar.component";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule
  ],
  declarations: [
    TopToolbarComponent
  ],
  exports: [
    TopToolbarComponent
  ]
})
export class TopToolbarModule {
}
